//     							                          //
//  Program: AllPropertyPayoutSidebar.jsx                           //
//  Application: Reports                                 //
//  Option: common component Report Sidebar TAbs         //
//  Developer: NP		                                 //
//  Date: 2022-04-13                                     //
//                                                        //
////////////////////////////////////////////////////////////

import React, { Component } from "react";
import { Link } from "react-router-dom";
class AllPropertyPayoutSidebar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      pathname: window.location.pathname,
      property_slug: sessionStorage.getItem("property_slug")
        ? sessionStorage.getItem("property_slug")
        : "",
    };
  }

  isPathActive(path) {
    return window.location.pathname.includes(path);
  }

  toggleHeaderMenu(e) {
    e.preventDefault();
    document.querySelector(".mobchildMenu").classList.toggle("d-none");
    document.querySelector("body").classList.toggle("az-header-menu-show");
  }

  toggleChildMenu(e) {
    e.preventDefault();
    const data = document.querySelector(".left");
    data.classList.replace("left", "hide");
  }

  render() {
    return (
      <>
        <div className="deskchildMenu">
          <div
            className="backtosubMenu"
            onClick={(event) => this.toggleChildMenu(event)}
          >
            <i className="fas fa-chevron-left"></i>Back to Payouts
          </div>
          <aside>
            <nav className="nav nav-pills flex-column pd-r-8">
              <ul>
                <li>
                  <ul>
                    {global.userPermissions.checkPermission(
                      "payout-payments-list",
                    ) && (
                      <li>
                        <Link
                          className={
                            this.isPathActive("res-payout-summary") ||
                            this.isPathActive("create-payout-resident") ||
                            this.isPathActive("view-payout-resident") ||
                            this.isPathActive("edit-payout-resident")
                              ? "nav-link active"
                              : "nav-link"
                          }
                          data-toggle="tab"
                          to="/res-payout-summary"
                        >
                          Resident Payouts
                        </Link>
                      </li>
                    )}
                    {global.userPermissions.checkPermission(
                      "payout-payments-list",
                    ) && (
                      <li>
                        <Link
                          className={
                            this.isPathActive("property-payout-summary") ||
                            this.isPathActive("create-payout-property") ||
                            this.isPathActive("view-payout-property") ||
                            this.isPathActive("edit-payout-property")
                              ? "nav-link active"
                              : "nav-link"
                          }
                          data-toggle="tab"
                          to="/property-payout-summary"
                        >
                          Property Payouts
                        </Link>
                      </li>
                    )}
                     {global.userPermissions.checkPermission(
                      "wh-payout-report-list",
                    ) && (
                      <li>
                        <Link
                          className={
                            this.isPathActive("wh-payout-report")
                              ? "nav-link active"
                              : "nav-link"
                          }
                          data-toggle="tab"
                          to="/wh-payout-report"
                        >
                          Revenue Share Payouts
                        </Link>
                      </li>
                    )}
                    {global.userPermissions.checkPermission(
                      "payout-payments-list",
                    ) && (
                      <li>
                        <Link
                          className={
                            this.isPathActive("stripe-transfer")
                              ? "nav-link active"
                              : "nav-link"
                          }
                          data-toggle="tab"
                          to="/stripe-transfer"
                        >
                          Transfers
                        </Link>
                      </li>
                    )}
                    {global.userPermissions.checkPermission(
                      "payout-payments-list",
                    ) && (
                      <li>
                        <Link
                          className={
                            this.isPathActive("resident-topup")
                              ? "nav-link active"
                              : "nav-link"
                          }
                          data-toggle="tab"
                          to="/resident-topup"
                        >
                          Top-ups
                        </Link>
                      </li>
                    )}
                   
                  </ul>
                </li>
              </ul>
            </nav>
          </aside>
        </div>
        <div className="mobchildMenu">
          <div className="d-flex justify-content-between align-items-center submenu">
            {/* New submenu */}
            <div className="newSubmenu">
              {/* <a href="/" className="back subMenu"> <i className="fas fa-chevron-left"></i> Listings</a> */}
              <span
                className="back"
                onClick={(event) => this.toggleHeaderMenu(event)}
              >
                <i className="fas fa-chevron-left"></i> Back to Reports
              </span>
              <ul>
                <li>
                  <span>Payouts</span>
                  <ul>
                    {global.userPermissions.checkPermission(
                      "payout-payments-list",
                    ) && (
                      <li>
                        <Link
                          className={
                            this.isPathActive("res-payout-summary")
                              ? "nav-link active"
                              : "nav-link"
                          }
                          data-toggle="tab"
                          to={"/res-payout-summary"}
                        >
                          Resident Payouts
                        </Link>
                      </li>
                    )}
                    {global.userPermissions.checkPermission(
                      "payout-payments-list",
                    ) && (
                      <li>
                        <Link
                          className={
                            this.isPathActive("property-payout-summary")
                              ? "nav-link active"
                              : "nav-link"
                          }
                          data-toggle="tab"
                          to={"/property-payout-summary"}
                        >
                          Property Payouts
                        </Link>
                      </li>
                    )}
                    {global.userPermissions.checkPermission(
                      "payout-payments-list",
                    ) && (
                      <li>
                        <Link
                          className={
                            this.isPathActive("stripe-total-payout")
                              ? "nav-link active"
                              : "nav-link"
                          }
                          data-toggle="tab"
                          to={"/stripe-transfer"}
                        >
                          Transfers
                        </Link>
                      </li>
                    )}
                    {global.userPermissions.checkPermission(
                      "payout-payments-list",
                    ) && (
                      <li>
                        <Link
                          className={
                            this.isPathActive("resident-topup")
                              ? "nav-link active"
                              : "nav-link"
                          }
                          data-toggle="tab"
                          to={"/resident-topup"}
                        >
                          Top-ups
                        </Link>
                      </li>
                    )}
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </>
    );
  }
}
export default AllPropertyPayoutSidebar;
